<template>
  <b-row class="job-facts">
    <b-col md="4" class="mb-3">
      <div class="fact-label">Roster</div>
      <div>{{ rosterLabel(job.roster) }}</div>
    </b-col>
    <b-col md="4" class="mb-3">
      <div class="fact-label">Experience level</div>
      <div>{{ experienceLevelLabel(job.experience_level) }}</div>
    </b-col>
    <b-col md="4" class="mb-3">
      <div class="fact-label">Start date</div>
      <div>{{ formatDate(job.start_date) }}</div>
    </b-col>
    <b-col md="4" class="mb-3">
      <div class="fact-label">Positions</div>
      <div>{{ job.positions || 1 }}</div>
    </b-col>
    <b-col md="4" class="mb-3">
      <div class="fact-label">Provided</div>
      <div>{{ providedLabel(job) }}</div>
    </b-col>
    <b-col md="8" class="mb-3">
      <div class="fact-label">Tickets required</div>
      <div v-if="tickets.length">
        <b-badge
          v-for="ticket in tickets"
          :key="ticket"
          variant="light"
          class="ticket-badge"
        >
          {{ ticket }}
        </b-badge>
      </div>
      <div v-else>-</div>
    </b-col>
    <b-col md="4" class="mb-3">
      <div class="fact-label">Company website</div>
      <!-- Only http(s) links are rendered as links; the API validates this too. -->
      <b-link
        v-if="websiteUrl"
        :href="websiteUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="website-link"
      >
        {{ websiteUrl }}
      </b-link>
      <div v-else>-</div>
    </b-col>
  </b-row>
</template>

<script>
import {
  experienceLevelLabel,
  formatDate,
  providedLabel,
  rosterLabel,
} from '@/utils/jobPostings'

// Roster, tickets, perks, experience and company website of a job ad. Shared
// by the company's job page and the tradie's job page (the API sends the same
// keys to both).
export default {
  name: 'JobListingDetails',

  props: {
    job: {
      type: Object,
      required: true,
    },
  },

  computed: {
    tickets() {
      return this.job.required_tickets || []
    },

    websiteUrl() {
      const url = this.job.company_website
      return url && /^https?:\/\//i.test(url) ? url : ''
    },
  },

  methods: {
    experienceLevelLabel,
    formatDate,
    providedLabel,
    rosterLabel,
  },
}
</script>

<style lang="scss" scoped>
.fact-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.25rem;
}

.ticket-badge {
  font-weight: 500;
  margin: 0 0.25rem 0.25rem 0;
}

.website-link {
  overflow-wrap: anywhere;
}
</style>
